import React from 'react'
import configureStore from 'utils/redux/configure-store'
import vtConfig from 'experiments/vtConfig'
import { Provider as ReduxProvider } from 'react-redux'

const withReduxProvider = WrappedComponent => {
  const store = configureStore({ experiments: { experiments: vtConfig } })
  return props => (
    <ReduxProvider store={store}>
      <WrappedComponent {...props} />
    </ReduxProvider>
  )
}

export default withReduxProvider
